import time from "src/utils/time";

export const SoundAlertsDelay = {
  keys: {
    "2_minutes": "2_minutes",
    "1_minute": "1_minute",
    "20_seconds": "20_seconds",
    "5_seconds": "5_seconds"
  },
  values: {
    "2_minutes": 120000,
    "1_minute": 60000,
    "20_seconds": 20000,
    "5_seconds": 5000
  },
  keysByValue: {
    120000: "2_minutes",
    60000: "1_minute",
    20000: "20_seconds",
    5000: "5_seconds"
  },
  strings: {
    "2_minutes": time.duration(120000).format("m__"),
    "1_minute": time.duration(60000).format("m__"),
    "20_seconds": time.duration(20000).format("s__"),
    "5_seconds": time.duration(5000).format("s__")
  }
};
